module.exports = __webpack_public_path__ + "img/0.06381567.png";